export default {
  推荐好友加入: `友達を紹介し`,
  赢取巴塞罗那VIP之旅:'バルセロナへの<span class="vipWord">VIP</span>旅行をゲットしよう ',

  成为EBC推荐官: "今こそ、EBC Financial Groupの優れた取引環境を友達に知らせる絶好のチャンスです。",
  立即参与: "今すぐ紹介",
  专属奖励等你拿: "あなたへの限定特典",
  您将获得以下奖励:'2025年5月23日までに、66人の友達を紹介することで豪華特典をゲット！',
  西班牙巴塞罗那之旅:'スペイン・バルセロナへの無料旅行',
  巴塞罗那足球俱乐部主场比赛VIP门票:'FCバルサのホーム試合VIPチケット',
  巴塞罗那足球俱乐部专属晚宴:'FCバルサ主催のディナーパーティへ招待',
  往返机票酒店住宿当地接送导服务:'往復航空券・ホテル宿泊・現地送迎込み',
  如何赢取大奖:'参加方法',
  登录EBC用户中心: "EBCマイページにログイン",
  "进入“大赛推荐官”活动页面": '「取引大会紹介キャンペーン」をクリック',
  生成您的邀请链接或二维码: "専用紹介リンクまたはQRコードを取得",
  成功推荐66人: "締切日までに66人の友達紹介を達成すると、豪華特典の対象に！",
成功推荐奖励:'紹介された友達は、最低$500を入金し、キャンペーン期間中に1回以上の取引を完了する必要があります',
  你还在等什么:'お見逃しなく！',
  EBC为交易者捉供更低点差:'EBCは、低スプレッド・競争力のあるリベート報酬・多彩な特典を提供いたします。お客様とバルセロナで会えることをお待ちしております！',
  每一次推荐: "紹介人数クリアだけで、バルセロナへの旅が手に入ります",
  参与规则: "参加ルール",
  成为EBC推荐官并邀请66人: "EBCの紹介者になって、66人の友達を招待しよう",
  所有被邀请人均入金大于等于$500: `招待された方は、最低500ドル以上を入金し、取引を完了する必要があります。`,
  参与方法: "参加方法",
  立即推荐: "今すぐ紹介を始めよう",
  
  巴萨荣耀之旅: "チャンピオンに続く道、FCバルセロナへの旅",
  每笔订单都是攻守博弈的艺术: `すべての取引は攻守のバランス。あなたの決断が市場でのゴールに。誇りと栄光、そしてFCバルセロナへの旅が、EBC100万ドル取引大会の勝者をお待ちしています。`,
  活动时间: "紹介期間：",
  "2025年2月22日": "2025年2月22日（土）08:00:00～2025年5月24日（土）05:59:59（日本時間）",
  活动规则: "キャンペーンルール",
  ruleList: [
    "本キャンペーンは、通常の紹介報酬やその他キャンペーンとの併用ができます。",
    "被紹介者は、500ドル以上の入金と取引を完了する必要があります。また、第三者振替による送金は対象外です。",
    "参加ルールに違反などがあった場合、本特典の対象外とさせていただくことがあります。",
    "紹介リンクを通じて登録されたアカウントは、紹介者変更を申請することができません。",
    "66人以上の有効なアカウントを開設された紹介者が招待の対象となり、VIP観覧席チケット及び航空券と宿泊費が支給されます。",
    "EBC Financial Groupは、本イベントの最終的な解釈権を有します。",
  ],
};
